// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.dashboard-kpi-card {
  background: #ffffff;
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  min-height: 130px;
  height: 100%;
}

.dashboard-kpi-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.dashboard-kpi-card__header-main {
  min-width: 0;
  flex: 1 1;
}

.dashboard-kpi-card__title-row {
  /* Inline cluster: label + ? stay left; avoid flex-grow pushing ? over the icon */
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  margin-bottom: 8px;
  max-width: 100%;
  min-width: 0;
}

.dashboard-kpi-card__title {
  margin: 0;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.08em;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  max-height: 2.7em;
}

.dashboard-kpi-card__title--uppercase {
  text-transform: uppercase;
}

.dashboard-kpi-card__value {
  color: #101828;
  font-size: clamp(1.125rem, 2.4vw, 1.5rem);
  font-weight: 700;
  line-height: 1.2;
  word-break: break-word;
  unicode-bidi: plaintext;
}

/* \`unicode-bidi: plaintext\` resolves the base direction from the value itself, and a KPI value is
   either digits ("٢,٣٣٨") or a latin-led amount ("PKR ٢٦,٤٦٥,٣١٦") — both resolve to LTR, which
   makes \`text-align: start\` park the value at the *left* edge of an RTL card while its title and
   trend sit at the right. Pin it to the RTL start edge so the whole card reads as one column;
   plaintext still keeps "PKR ٢٦,٤٦٥,٣١٦" in its LTR order rather than flipping it. */
[dir=rtl] .dashboard-kpi-card__value {
  text-align: right;
}

.dashboard-kpi-card__sublabel {
  margin: 6px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  color: #98a2b3;
}

.dashboard-kpi-card__period {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  color: #667085;
}

.dashboard-kpi-card__change {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
  /* Always "arrow + signed percentage" — a single LTR unit. Without this, an RTL paragraph
     resolves the leading "-" and trailing "%" to RTL while the digits stay LTR, rendering
     "-13.2%" as "%13.2-". \`direction: ltr\` also keeps the trend arrow leading the number,
     matching English. The span as a whole still sits at the RTL card's start edge. */
  direction: ltr;
  unicode-bidi: isolate;
}

.dashboard-kpi-card__change--positive {
  color: #0f9f60;
}

.dashboard-kpi-card__change--negative {
  color: #d92d20;
}

.dashboard-kpi-card__change--neutral {
  color: #667085;
}

.dashboard-kpi-card__comparison {
  color: #667085;
  font-weight: 500;
}

.dashboard-kpi-card__description,
.dashboard-kpi-card__footer {
  margin: 0;
  color: #667085;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
}

.dashboard-kpi-card__trend-unavailable {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #98a2b3;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
}

.dashboard-kpi-card__trend-unavailable-label {
  display: inline-flex;
  align-items: center;
}

.dashboard-kpi-card__trend-unavailable .definition-tooltip__trigger {
  width: 16px;
  height: 16px;
  min-width: 16px;
  font-size: 10px;
}

.dashboard-kpi-card__trend-unavailable .definition-tooltip__popover {
  left: 0;
  right: auto;
}

.dashboard-kpi-card__trend-unavailable .definition-tooltip.definition-tooltip--align-end .definition-tooltip__popover {
  left: auto;
  right: 0;
}

.dashboard-kpi-card__description--positive,
.dashboard-kpi-card__footer--positive {
  color: #0f9f60;
}

.dashboard-kpi-card__description--negative,
.dashboard-kpi-card__footer--negative {
  color: #d92d20;
}

.dashboard-kpi-card__description--neutral,
.dashboard-kpi-card__footer--neutral {
  color: #667085;
}

.dashboard-kpi-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #eef4ff;
  color: #356fb6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dashboard-kpi-card__icon svg {
  width: 22px;
  height: 22px;
}

.dashboard-kpi-card__accessory {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
}

.dashboard-kpi-card .definition-tooltip {
  flex-shrink: 0;
}

.dashboard-kpi-card:has(.definition-tooltip:hover),
.dashboard-kpi-card:has(.definition-tooltip:focus-within) {
  z-index: 10;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/common/DashboardKpiCard/DashboardKpiCard.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AAEF;;AACA;EACE,YAAA;EACA,SAAA;AAEF;;AACA;EACE,iFAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAEF;;AACA;EACE,SAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,iBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,cAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;AAEF;;AACA;;;;qFAAA;AAKA;EACE,iBAAA;AAEF;;AACA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA;;;qFAAA;EAIA,cAAA;EACA,qBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;EACA,gBAAA;AAEF;;AACA;;EAEE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAEF;;AACA;EACE,OAAA;EACA,WAAA;AAEF;;AACA;EAGE,UAAA;EACA,QAAA;AAAF;;AAGA;;EAEE,cAAA;AAAF;;AAGA;;EAEE,cAAA;AAAF;;AAGA;;EAEE,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;;EAEE,WAAA;EACA,kBAAA;AAAF","sourcesContent":[".dashboard-kpi-card {\n  background: #ffffff;\n  border: 1px solid #dbe4f0;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n  min-height: 130px;\n  height: 100%;\n}\n\n.dashboard-kpi-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.dashboard-kpi-card__header-main {\n  min-width: 0;\n  flex: 1;\n}\n\n.dashboard-kpi-card__title-row {\n  /* Inline cluster: label + ? stay left; avoid flex-grow pushing ? over the icon */\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: nowrap;\n  margin-bottom: 8px;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.dashboard-kpi-card__title {\n  margin: 0;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 100%;\n  color: #667085;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.35;\n  letter-spacing: 0.08em;\n  white-space: normal;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-clamp: 2;\n  max-height: calc(1.35em * 2);\n}\n\n.dashboard-kpi-card__title--uppercase {\n  text-transform: uppercase;\n}\n\n.dashboard-kpi-card__value {\n  color: #101828;\n  font-size: clamp(1.125rem, 2.4vw, 1.5rem);\n  font-weight: 700;\n  line-height: 1.2;\n  word-break: break-word;\n  unicode-bidi: plaintext;\n}\n\n/* `unicode-bidi: plaintext` resolves the base direction from the value itself, and a KPI value is\n   either digits (\"٢,٣٣٨\") or a latin-led amount (\"PKR ٢٦,٤٦٥,٣١٦\") — both resolve to LTR, which\n   makes `text-align: start` park the value at the *left* edge of an RTL card while its title and\n   trend sit at the right. Pin it to the RTL start edge so the whole card reads as one column;\n   plaintext still keeps \"PKR ٢٦,٤٦٥,٣١٦\" in its LTR order rather than flipping it. */\n[dir=\"rtl\"] .dashboard-kpi-card__value {\n  text-align: right;\n}\n\n.dashboard-kpi-card__sublabel {\n  margin: 6px 0 0;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: #98a2b3;\n}\n\n.dashboard-kpi-card__period {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #667085;\n}\n\n.dashboard-kpi-card__change {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 700;\n  /* Always \"arrow + signed percentage\" — a single LTR unit. Without this, an RTL paragraph\n     resolves the leading \"-\" and trailing \"%\" to RTL while the digits stay LTR, rendering\n     \"-13.2%\" as \"%13.2-\". `direction: ltr` also keeps the trend arrow leading the number,\n     matching English. The span as a whole still sits at the RTL card's start edge. */\n  direction: ltr;\n  unicode-bidi: isolate;\n}\n\n.dashboard-kpi-card__change--positive {\n  color: #0f9f60;\n}\n\n.dashboard-kpi-card__change--negative {\n  color: #d92d20;\n}\n\n.dashboard-kpi-card__change--neutral {\n  color: #667085;\n}\n\n.dashboard-kpi-card__comparison {\n  color: #667085;\n  font-weight: 500;\n}\n\n.dashboard-kpi-card__description,\n.dashboard-kpi-card__footer {\n  margin: 0;\n  color: #667085;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.dashboard-kpi-card__trend-unavailable {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #98a2b3;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.dashboard-kpi-card__trend-unavailable-label {\n  display: inline-flex;\n  align-items: center;\n}\n\n.dashboard-kpi-card__trend-unavailable .definition-tooltip__trigger {\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  font-size: 10px;\n}\n\n.dashboard-kpi-card__trend-unavailable .definition-tooltip__popover {\n  left: 0;\n  right: auto;\n}\n\n.dashboard-kpi-card__trend-unavailable\n  .definition-tooltip.definition-tooltip--align-end\n  .definition-tooltip__popover {\n  left: auto;\n  right: 0;\n}\n\n.dashboard-kpi-card__description--positive,\n.dashboard-kpi-card__footer--positive {\n  color: #0f9f60;\n}\n\n.dashboard-kpi-card__description--negative,\n.dashboard-kpi-card__footer--negative {\n  color: #d92d20;\n}\n\n.dashboard-kpi-card__description--neutral,\n.dashboard-kpi-card__footer--neutral {\n  color: #667085;\n}\n\n.dashboard-kpi-card__icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  background: #eef4ff;\n  color: #356fb6;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.dashboard-kpi-card__icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.dashboard-kpi-card__accessory {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.dashboard-kpi-card .definition-tooltip {\n  flex-shrink: 0;\n}\n\n.dashboard-kpi-card:has(.definition-tooltip:hover),\n.dashboard-kpi-card:has(.definition-tooltip:focus-within) {\n  z-index: 10;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
